import Base from '../../ts/_base';

export default class MoveFocus extends Base {
    private attributeName: string ='data-move-focus';

    constructor() {
        super();
        this.controller = this.controller.bind(this);
    }

    initialize(): void {
        this.subscribeToEvent('click', `[${this.attributeName}]`, this.controller);
    }

    controller(e: Event): void {
        const eventTarget = e.currentTarget as HTMLElement;
        const elementSelector = eventTarget.getAttribute(this.attributeName);
        const isExpanded = eventTarget.getAttribute('aria-expanded');
        const isToggle = typeof isExpanded !== typeof undefined;
        if(isToggle && isExpanded == 'false') return;
        setTimeout(()=>this.moveFocusToElement(elementSelector), 200);
    }

    moveFocusToElement(selector: string): void {
        const elementToFocus = this.queryElm(selector) as HTMLElement;
        elementToFocus && elementToFocus.focus();
    }
}